import React from 'react';
import classNames from 'classnames';
import { useLockBodyScroll } from '@fiverr-private/hooks';
import { OverlayProps } from './types';
import { BASE_Z_INDEX } from './constants';

import classes from './index.module.scss';

const zIndex = BASE_Z_INDEX + 1300;

const Overlay = ({
  children,
  opacity = 'low',
  lockBodyScroll = true,
  background = 'grey',
  position = 'fixed',
  className,
  onClick,
  dataTestId,
  style,
}: OverlayProps) => {
  useLockBodyScroll(lockBodyScroll);
  const backgroundColor = classes[`${background}-${opacity}`];
  const overlay = classes.overlay;

  return (
    <div
      style={{
        ...style,
        zIndex,
        position,
      }}
      className={classNames(backgroundColor, overlay, className)}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

Overlay.displayName = 'Overlay';

export default Overlay;
